import * as Sentry from '@sentry/browser';
import { isHttpError } from '@utils/common.utils';
import { getClientContext } from '@utils/get-client-context';

function handleRuntimeError(error: unknown): void {
  console.error(error);

  // if fetchWithLogs doesn't have a .catch block, then error will propagate here
  // this prevents double logging
  if (isHttpError(error)) {
    return;
  }

  Sentry.withScope((scope) => {
    scope.setContext('client', getClientContext());
    Sentry.captureException(error);
  });
}

export function registerGlobalErrorHandler(): void {
  window.addEventListener('error', (event) => {
    handleRuntimeError(event.error ?? event.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    handleRuntimeError(event.reason);
  });
}
